import { render } from "./blog.vue?vue&type=template&id=32a76503&scoped=true"
const script = {}

import "./blog.vue?vue&type=style&index=0&id=32a76503&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a76503"]])

export default __exports__